<template>
  <section class="area-workspace">
    <!-- 顶部操作区 -->
    <table-toolbar
      :search.sync="search"
      :show-refresh="true"
      :show-export="true"
      :show-column-settings="true"
      :columns="columnOptions"
      :visible-columns.sync="visibleColumns"
      :default-columns="defaultColumns"
      :fixed-columns="['# ID', '环境名称', '操作']"
      @refresh="handleReset"
      @export="handleExport"
    >
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddEnv" class="btn-action">新增域名</el-button>
      </template>
    </table-toolbar>

    <!-- 表格主体 -->
    <table-page :loading="loading" :empty="tables.length === 0" :show-top-pagination="false" :show-bottom-pagination="false" @retry="fetchData">
      <el-table :data="tables" stripe style="width: 100%" class="premium-table">
        <el-table-column key="col-id" prop="id" label="# ID" width="90">
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-name" prop="name" label="环境名称" min-width="160">
          <template slot-scope="scope">
            <el-link type="primary" class="cell-name-link" @click="handleUpdateEnv(scope.$index, scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column key="col-env" v-if="visibleColumns.includes('env')" prop="env" label="环境ENV" width="160">
          <template slot-scope="scope">
            <span class="mono-tag">{{ scope.row.env }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-gatewayUrl" v-if="visibleColumns.includes('gatewayUrl')" prop="gatewayUrl" label="GateWay 地址" min-width="200">
          <template slot-scope="scope">
            <span class="url-text" v-if="scope.row.gatewayUrl">{{ scope.row.gatewayUrl }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-callbackUrl" v-if="visibleColumns.includes('callbackUrl')" prop="callbackUrl" label="CallBack 地址" min-width="200">
          <template slot-scope="scope">
            <span class="url-text" v-if="scope.row.callbackUrl">{{ scope.row.callbackUrl }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-actions" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-dropdown @command="cmd => handleActionCommand(cmd, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑域名
                </el-dropdown-item>
                <el-dropdown-item command="delete" style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;"></i> 删除域名
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <!-- 新增/编辑弹窗 -->
    <form-drawer :visible.sync="dialogVisible" :title="type ? '编辑网关域名' : '新增网关域名'" :icon="type ? 'el-icon-edit-outline' : 'el-icon-plus'" :loading="saveLoading" width="600px" @close="handleCloseDialog" @save="handleSaveDialog">
      <el-form :model="form" label-position="right" label-width="150px" :rules="rules" ref="form" size="small" class="drawer-horizontal-form">
        <el-form-item label="环境ID" prop="id">
          <el-input v-model.number="form.id" :disabled="type" placeholder="请输入环境ID（数字）"></el-input>
        </el-form-item>
        <el-form-item label="环境名称" prop="name">
          <el-input v-model.trim="form.name" placeholder="示例：简体-xiayixing"></el-input>
        </el-form-item>
        <el-form-item label="环境ENV" prop="env">
          <el-input v-model.trim="form.env" placeholder="示例：zhcn-xiayi"></el-input>
        </el-form-item>
        <el-form-item label="GateWay 地址" prop="gatewayUrl">
          <el-input v-model.trim="form.gatewayUrl" placeholder="示例：https://gw.xiayixing.com"></el-input>
        </el-form-item>
        <el-form-item label="CallBack 地址" prop="callbackUrl">
          <el-input v-model.trim="form.callbackUrl" placeholder="示例：https://sgw.xiayixing.com"></el-input>
        </el-form-item>
      </el-form>
    </form-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import TableToolbar from '@/components/TableToolbar/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import FormDrawer from '@/components/FormDrawer/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'index',
  components: { TableToolbar, TablePage, FormDrawer },
  created () {
    this.fetchData()
  },
  computed: {
    id () {
      return this.$store.getters.id
    },
    tables () {
      const search = this.search
      if (search) {
        const keyword = search.toLowerCase()
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(keyword) > -1
          })
        })
      }
      return this.tableData
    },
    columnOptions () {
      return [
        { prop: 'env', label: '环境ENV' },
        { prop: 'gatewayUrl', label: 'GateWay 地址' },
        { prop: 'callbackUrl', label: 'CallBack 地址' }
      ]
    },
    defaultColumns () {
      return this.columnOptions.map(item => item.prop)
    }
  },
  watch: {
    id (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData()
    }
  },
  data () {
    return {
      tableData: [],
      envData: {},
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      search: '',
      visibleColumns: ['env', 'gatewayUrl', 'callbackUrl'],
      form: {
        id: this.id
      },
      AppOptions: [],
      type: false, // 默认状态为新增  true 为修改 false为新增
      index: 0, // 用于修改时保存位置
      rules: {
        id: [{ type: 'number', required: true, message: '请输入数字，且不能为空', trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '请输入环境名称', trigger: 'blur' }],
        env: [{ type: 'string', required: true, message: '请输入环境描述', trigger: 'blur' }],
        gatewayUrl: [{ type: 'url', required: true, message: 'URL格式不正确', trigger: 'blur' }],
        callbackUrl: [{ type: 'url', required: true, message: 'URL格式不正确', trigger: 'blur' }]
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      // 获取已配置环境
      api.getAreas().then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleReset () {
      this.search = ''
      this.fetchData()
    },
    // 新增平台
    handleAddEnv () {
      this.type = false
      const id = this.tableData.length ? this.tableData[this.tableData.length - 1].id : 0
      this.form = {
        id: id + 1
      }
      this.dialogVisible = true
    },
    // 修改平台
    handleUpdateEnv (index, rowData) {
      this.type = true
      this.index = index
      this.form = Object.assign({}, rowData)
      this.dialogVisible = true
    },
    // 提交数据 新增 或 修改
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          const params = Object.assign({}, this.form)
          const f = this.type ? api.updateArea : api.addArea
          f(params).then(res => {
            if (this.type) {
              this.tableData.splice(this.index, 1, res)
            } else {
              this.tableData.push(res)
            }
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.dialogVisible = false
          }).finally(() => {
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    },
    // 删除
    handleDeleteEnv (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteArea(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    // 操作列下拉菜单分发
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleUpdateEnv(index, row)
      } else if (command === 'delete') {
        this.handleDeleteEnv(row.id, index)
      }
    },
    handleExport () {
      const worksheet = XLSX.utils.json_to_sheet(this.tables)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '网关域名')
      XLSX.writeFile(workbook, `网关域名-${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    // 关闭弹窗
    handleCloseDialog () {
      this.dialogVisible = false
      if (this.$refs.form) this.$refs.form.clearValidate()
    }
  }
}
</script>

<style scoped>
.area-workspace {
  padding: 16px 24px;
}

/* 过滤筛选卡片 */
.filter-card {
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 16px 24px;
  border-radius: var(--border-radius-card);
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-left-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-right-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.btn-reset {
  background-color: var(--bg-page) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.btn-reset:hover {
  background-color: var(--bg-hover) !important;
  color: var(--text-main) !important;
  border-color: var(--border-hover) !important;
}

.btn-setting {
  flex-shrink: 0;
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-setting:hover {
  background-color: var(--bg-hover) !important;
  border-color: var(--border-hover) !important;
  color: var(--text-main) !important;
}

.search-input {
  width: 220px;
  flex-shrink: 0;
}

.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  border-color: var(--border-color);
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  background-color: var(--bg-card);
  color: var(--text-main);
  transition: all 0.2s ease;
}

.search-input :deep(.el-input__inner:hover) { border-color: var(--border-hover); }
.search-input :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* 列配置 Popover 内部样式 */
.popover-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-main);
  padding: 6px 4px;
}

.popover-divider {
  height: 1px;
  background: var(--border-color);
  margin: 6px 0;
}

.popover-body-scroll {
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
}

.popover-body-scroll::-webkit-scrollbar {
  width: 4px;
}

.popover-body-scroll::-webkit-scrollbar-thumb {
  background: var(--border-hover);
  border-radius: 2px;
}

.popover-body-scroll :deep(.el-checkbox) {
  display: block;
  margin-bottom: 8px;
  margin-right: 0;
}

/* 表格卡片 */
.table-card {
  padding: 20px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid var(--border-light);
  box-shadow: var(--shadow-base);
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  color: var(--text-main) !important;
}

.premium-table::before { display: none !important; }

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right .el-table__fixed-header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) { transition: background-color 0.2s ease; }
.premium-table :deep(.el-table__row:hover) td,
.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.cell-id,
.cell-text-gray {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
}

.cell-id {
  font-weight: 600;
  color: var(--text-muted);
}

.cell-text-gray {
  color: var(--text-muted);
}

.cell-name-link {
  font-size: 13.5px !important;
  font-weight: 700 !important;
  text-decoration: none !important;
}

/* ENV 等宽标签 */
.mono-tag {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  background: var(--bg-hover);
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
}

/* URL 文本 */
.url-text {
  font-size: 12px;
  color: var(--text-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  word-break: break-all;
}

.text-muted { color: var(--text-muted); font-size: 13px; }

/* 操作列三点按钮 */
.action-btn {
  font-size: 12px;
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  background: var(--bg-card);
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: var(--bg-hover);
  color: var(--text-main);
  border-color: var(--border-hover);
}

/* 弹窗 */
.premium-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  background-color: var(--bg-card) !important;
}

/* 表单 */
.area-premium-form :deep(.el-form-item__label) {
  font-weight: 600;
  color: var(--text-main);
  padding-bottom: 6px !important;
}

.area-premium-form :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: var(--border-color);
  background-color: var(--bg-card);
  color: var(--text-main);
}

.area-premium-form :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
</style>
